import { getObjectValueByPath } from "vuetify/lib/util/helpers";

export default function groupByKey( arr, key ) {
	return arr.reduce( ( objectsByKeyValue, obj ) => {
		const value = getObjectValueByPath( obj, key );

		objectsByKeyValue[value] = ( objectsByKeyValue[value] || [] ).concat( obj );

		return objectsByKeyValue;
	}, {} );
}
